import './covid-banner.scss';

function addCovidMessage() {
  const nav = document.querySelector('.site-header__nav');
  const messCont = document.createElement('div');
  messCont.setAttribute('class', 'avalon-covid-message');
  const message = document.createElement('h4');
  /* eslint-disable max-len */
  const messageT = document.createTextNode('In light of the COVID-19 pandemic, we advise that you check local guidelines before making plans. If you choose to travel, please do so safely and responsibly.');
  message.appendChild(messageT);
  messCont.appendChild(message);
  if (nav) {
    nav.after(messCont);
  }
}

addCovidMessage();
